import type { GetAgencyProfileQuery } from '@sortlist-frontend/data-fetching/public-types';

type OfficeNode = NonNullable<NonNullable<GetAgencyProfileQuery['agency']['offices']['nodes']>[0]>;

const findFirstOfficeIndex = (offices: OfficeNode[] | undefined, office: OfficeNode) => {
  const index = offices?.findIndex((el) => el.id === office.id);
  return index !== -1 ? index : null;
};

const hasFreeBrandingModule = (brandingModule: string | null): boolean => ['free', null].includes(brandingModule);

export type { OfficeNode };
export { findFirstOfficeIndex, hasFreeBrandingModule };
